import api from 'plugin/api';

/**
 *  @description 제품정보 목록 API
 */

async function productList(params) {
  const url = '/sfsh/standard/product';

  const response = await api.get(url, { params });
  return response;
}

export { productList };
